import { mapActions, mapState } from "vuex"
import dayjs from 'dayjs';
import { TYPE_LABLES_MAP, STANDART_TYPE, STATUS_LABELS_MAP, PENDING_REVIEW_STATUS } from "../../constants/network-join-application"

export default {
	components: {},
	filters: {
		formatDate(value) {
			return value ? dayjs(value).format('DD.MM.YYYY') : null;
		}
	},
	data() {
		return {
			selectedItem: null,
			columns: [
				{
					label: '№ Заяви',
					prop: 'number'
				},
				{
					label: 'Замовник',
					prop: 'customer'
				},
				{
					label: 'Код платника податків',
					prop: 'customerID',
				},
				{
					label: 'Адреса об\'єкта',
					prop: 'objectAddress',
				},
				{
					label: 'Назва об\'єкта',
					prop: 'objectName',
				},
				{
					label: 'Статус',
					prop: 'status',
				},
				{
					label: 'Тип приєднання',
					prop: 'typeJoin',
				},
				{
					label: 'Дата реєстрації',
					prop: 'registrationDate',
				},
				{
					label: 'Дата оплати',
					prop: 'paymentDate',
				},
				{
					label: 'Дата надання послуг',
					prop: 'serviceDate',
				},
				{
					label: 'Коментар',
					prop: 'comment',
				}
			],
			limit: 10,
			offset: 0,
			currentPage: 1,
			selectedRow: {}
		}
	},
	computed: {
		...mapState({
			applications: state => state.NetworkJoinApplication.applications,
			total: (state) => state.NetworkJoinApplication.total,
			loading: state => state.NetworkJoinApplication.loading,
			refresh: state => state.NetworkJoinApplication.refresh,
		})
	},
	methods: {
		...mapActions(['getNetworkJoinApplications', 'setRefresh', 'deleteNetworkJoinApplication']),
		indexMethod(index) {
			if (this.currentPage === 1) {
				return index;
			}
			return index + this.offset;
		},
		editApplication(row) {
			this.$emit("editRow", row)
		},
		deleteApplication(row) {
			const { _id: id } = row
			this.deleteNetworkJoinApplication({ id }).then(() => {
				this.$notify.success({
					title: 'Успіх',
					message: 'Заяву успішно видалено!',
				});
				this.getNetworkJoinApplications({ limit: this.limit, offset: this.offset });
			}).catch(() => {
				this.$notify.error({
					title: 'Помилка!',
					message: "Сталася помилка під час видалення заяви.",
				});
			});
		},
		getApplicationType(type) {
			return TYPE_LABLES_MAP[type] || TYPE_LABLES_MAP[STANDART_TYPE]
		},
		getApplicationStatus(status) {
			return STATUS_LABELS_MAP[status] || STATUS_LABELS_MAP[PENDING_REVIEW_STATUS]
		}
	},
	watch: {
		currentPage(val) {
			this.offset = this.limit * val - this.limit;
			this.getNetworkJoinApplications({ limit: this.limit, offset: this.offset });
		},
		loading(val) {
			if (!val) {
				this.setRefresh(false);
			}
		},
		refresh(val) {
			if (val) {
				this.getNetworkJoinApplications({ limit: this.limit, offset: this.offset });
			}
		}
	},
	beforeMount() {
		this.getNetworkJoinApplications({ limit: this.limit, offset: this.offset });
	}
}